import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from './component/header';
import LoginSignup from './pages/LoginSignup';
import Footer from "./component/footer";
import FormPage1 from "./pages/formPage1";
import FormPage2 from "./pages/formPage2";
import FormPage3 from "./pages/formPage3";
import FormStart from "./pages/formStart";
import Payment from "./pages/payment";
import FormPreview from "./pages/formPreview";
import FeesSubmitted from "./pages/feesSubmitted";
import SecureRoute from "./protectedRoute/secureRoute";
import PageNotfound from "./pages/pageNotfound";



function App() {

  document.addEventListener('contextmenu', (e) => e.preventDefault());

function ctrlShiftKey(e, keyCode) {
  return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
}

document.onkeydown = (e) => {
  // Disable F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
  if (
    e.keyCode === 123 ||
    ctrlShiftKey(e, 'I') ||
    ctrlShiftKey(e, 'J') ||
    ctrlShiftKey(e, 'C') ||
    (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0))
  )
    return false;
};

  return (
    <Router>
      <Header/>
      <Routes>
        <Route path="/" element={<LoginSignup />} />
        <Route path="/FormStart" element={<SecureRoute><FormStart /></SecureRoute> } />
        <Route path="/FormPage1" element={<SecureRoute><FormPage1 /></SecureRoute> } />
        <Route path="/FormPage2" element={<SecureRoute><FormPage2 /></SecureRoute> } />
        <Route path="/FormPage3" element={<SecureRoute><FormPage3 /></SecureRoute> } />
        <Route path="/FormPreview" element={<SecureRoute><FormPreview /></SecureRoute> } />
        <Route path="/FeesSubmitted" element={<SecureRoute><FeesSubmitted /></SecureRoute> } />
        <Route path="/Payment" element={<SecureRoute><Payment /></SecureRoute> } />
        <Route path="*" element={< PageNotfound />} />
        
      </Routes>
      <Footer/>
    </Router>
  );
}
export default App;
